import { usePermanent } from "@suse-o11y/use-permanent";
import Konva from "konva";
import React from "react";

import { AssignNodeField } from "./_AssignNodeField";
import { Shape, type ShapeConfig } from "./Shape";

interface TextConfig extends ShapeConfig, Pick<Konva.TextConfig, "fontSize" | "fontFamily"> {
	text: string | number;
	align?: "left" | "center" | "right" | "justify";
}

export interface TextProps extends Omit<TextConfig, "text"> {
	children: string | number;
}

export const Text: React.FC<TextProps> = ({ fontSize, fontFamily, align, children, ...config }) => {
	const text = usePermanent(
		() =>
			new Konva.Text({
				...config,
				text: children.toString(),
				fontSize,
				fontFamily,
				align,
			}),
	);

	return (
		<Shape instance={text} {...config}>
			<AssignNodeField instance={text} method="text" value={children.toString()} />

			{fontSize != null && <AssignNodeField instance={text} method="fontSize" value={fontSize} />}
			{fontFamily != null && <AssignNodeField instance={text} method="fontFamily" value={fontFamily} />}
			{align != null && <AssignNodeField instance={text} method="align" value={align} />}
		</Shape>
	);
};
